import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Lock, User, LogIn } from 'lucide-react';
import axios from 'axios';
import './Admin.css';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api/admin`;

const AdminLogin = () => {
  const navigate = useNavigate();
  const [credentials, setCredentials] = useState({
    username: '',
    password: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await axios.post(`${API}/login`, credentials);
      
      // Stocker le token dans localStorage
      localStorage.setItem('admin_token', response.data.token);
      localStorage.setItem('admin_username', response.data.username);
      
      // Rediriger vers le dashboard
      navigate('/admin/dashboard');
    } catch (err) {
      setError(err.response?.data?.detail || 'Identifiants incorrects');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-login-page">
      {/* Background Video */}
      <div className="page-video-background">
        <iframe
          className="page-background-video"
          src="https://www.youtube.com/embed/AcQHHKsBFyE?autoplay=1&mute=1&loop=1&playlist=AcQHHKsBFyE&controls=0&showinfo=0&rel=0&modestbranding=1&playsinline=1&disablekb=1&iv_load_policy=3"
          title="CYGA EVENEMENT - Background"
          frameBorder="0"
          allow="autoplay; encrypted-media"
        ></iframe>
      </div>

      <div className="admin-login-container">
        <div className="admin-login-box">
          <div className="admin-login-header">
            <img 
              src="https://customer-assets.emergentagent.com/job_cyga-refresh/artifacts/iagmxpji_Cyga%20events%20Visuel%20Site-02.png" 
              alt="Cyga Events Logo" 
              className="admin-logo"
            />
            <h1>Panneau d'Administration</h1>
            <p>CYGA ÉVÉNEMENT</p>
          </div>

          <form onSubmit={handleSubmit} className="admin-login-form">
            <div className="admin-form-group">
              <label>
                <User size={20} />
                Identifiant
              </label>
              <input
                type="text"
                value={credentials.username}
                onChange={(e) => setCredentials({ ...credentials, username: e.target.value })}
                placeholder="Entrez votre identifiant"
                required
                autoFocus
              />
            </div>

            <div className="admin-form-group">
              <label>
                <Lock size={20} />
                Mot de passe
              </label>
              <input
                type="password"
                value={credentials.password}
                onChange={(e) => setCredentials({ ...credentials, password: e.target.value })}
                placeholder="Entrez votre mot de passe"
                required
              />
            </div>

            {error && (
              <div className="admin-error-message">
                {error}
              </div>
            )}

            <button type="submit" className="admin-login-button" disabled={loading}>
              <LogIn size={20} />
              {loading ? 'Connexion...' : 'Se connecter'}
            </button>
          </form>

          <div className="admin-login-footer">
            <button onClick={() => navigate('/')} className="back-to-site-button">
              ← Retour au site
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
